import {tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';

import {Observable} from 'rxjs';

import {ErrorHandler} from './error_handler';


declare var jquery: any;
declare var $: any;

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  notDisabled_btn;
  count = 0;

  constructor(
    public errorHandler: ErrorHandler
  ) {

    this.notDisabled_btn = $('button.mat-button:not(:disabled)');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {

      }
      , (err: any) => {
        console.error('Intercept Error', err);
        if (err instanceof HttpErrorResponse) {
          this.errorHandler.handleError(err);
        }
      }));
  }
}
